module.exports = __webpack_public_path__ + "img/simon_zsuzsi_c80_A3-02.6a86a9eb.jpg";